import { Snackbar, Button, Alert, AlertProps } from '@mui/material'
import {useState, forwardRef, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {onClearAlert, onErrorAlert, onSuccessAlert} from "../../actions";
import {AnimatePresence, motion} from 'framer-motion'
import FramerFade from "../Animation/Fade";
import {useTranslation} from "react-i18next";

const SnackbarAlert = forwardRef(
    function SnackbarAlert(props, ref) {
      return <Alert elevation={3}  ref={ref} {...props} />
    }
)

const MuiSnackbar = () => {
  const status = useSelector( state => state.message.status)
  const message = useSelector( state => state.message.message)
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const {t} = useTranslation();
  const handleClose = (event,reason) => {
    // if (reason === 'clickaway') {
    //   return
    // }
    setOpen(false)
    dispatch(onClearAlert())
  }

  useEffect(() => {
    if (status === 'success' || status === 'error' || status === 'info'){
      setOpen(true)
    }

  }, [status]);

    const handleCellCopyClick = (text) => {
        const textToCopy = text
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {

                })
                .catch((err) => {

                });
        }

    };


  return (
      <AnimatePresence>
        <motion.div>
          {/*<Button onClick={() => setOpen(true)}>Submit</Button>*/}

          {
            status!=='clear' &&
              <Snackbar open={open} autoHideDuration={5000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center'}}>
                <SnackbarAlert variant="filled"  onClose={handleClose} severity={status}  >
                    {t(message)}
                </SnackbarAlert>
              </Snackbar>
          }

        </motion.div>
      </AnimatePresence>
  )
}

export default MuiSnackbar